import React from "react";
import RootlyIcon from "src/components/ui/icons/rootly";
import SlackIcon from "src/components/ui/icons/slack";

export function SlackManagedByRootly() {
  return (
    <div className="flex flex-col items-center justify-center py-4">
      <div className="flex items-center justify-center mb-6">
        <SlackIcon className="h-10 w-10" />
        <span className="mx-2 text-xl">+</span>
        <RootlyIcon className="h-10 w-10 p-1 rounded-sm bg-white text-blue-600" />
      </div>
      <div className="text-center space-y-4">
        <p className="text-muted-foreground">
          Slack installation is managed by Rootly.
        </p>
      </div>
    </div>
  );
}
